import { OAuthService } from 'angular-oauth2-oidc';
import { AuthenticationExt } from '../extensions/authentication-extensions';
import { SettingsService } from '../services/settings.service';
import { RouterStateSnapshot, Router } from '@angular/router';

export function OauthServiceInitializer(provider: OAuthService, settings: SettingsService, router: Router) {

  return () => {
    const oauth = AuthenticationExt.Configure(provider);
    // oauth.enableAutoTokenRefresh();
    return new Promise((resolve, reject) => {

      oauth.initialize()
        .subscribe((loggedIn) => {
          if (!loggedIn) {
            reject('user is not logged in');
          }
          oauth.populateUser()
            .subscribe((user) => {
              // console.log('user received', user);
              settings.setUser(user);
              resolve(true);
              if (router && provider.state) {
                const uri = decodeURIComponent(provider.state);
                router.navigateByUrl(uri);
              }
            });
        });
    });
  };
}
